module.exports = __webpack_public_path__ + "img/151.newspaper.19098c66.svg";